import {
    createClient,
    createClientContact,
    createClientEnrollment,
    deleteClient,
    deleteClientContact,
    deleteClientEnrollment,
    editClient,
    editClientContact,
    editClientEnrollment,
    terminateClientEnrollment,
    getClients,
    getClientsById,
    getClientsContacts,
    getClientsEnrollment,
    addFilesToClientAuth,
    removeFilesFromClientAuth,
    editFileNameOfClientAuth,
    changeEnrollmentType,
    addAddress,
    editAddress,
    deleteAddress,
    getSchedulingAddress,
    setSchedulingAddress,
    clearSchedulingAddress,
    assignStaff,
    getAssignedStaffs,
    removeClientStaff,
    editClientStatus,
    editAssignedStaff,
    getBasicClients,
    getBasicActiveClients,
    getClientsAuthorizationsAppt,
    addClientAuthorization,
    getClientAuthorization,
    getAuthUtilization,
    inactivateClientAuthorization,
    cancelClientAuthorization,
    deleteClientAuthorization,
    deleteAuthorizedService,
    clientAuthorizationVisible,
    editClientAuthorization,
    getClientAuthFiles,
    getClientAuthorizationAppt,
    getEnrollmentPayers,
    resendClientInvite,
    getClientsContactInfo,
    getClientForms,
    deleteClientForms,
    addClientForms,
    createIntakeForm,
    linkContactToClient,
    grantPortalAccess,
    revokePortalAccess,
    setClientContactPassword,
    getClientSections,
    createClientSection,
    editClientSection,
    deleteClientSection,
    removeClientAuthorization, getClientExpiration,
    getClientAllNotes, deleteClientAllNotes,
} from './client.action';

export { clientReducer } from './client.reducer';
export { watchClient } from './client.saga';

export const clientActions = {
    getClients,
    getClientExpiration,
    getBasicClients,
    getBasicActiveClients,
    createClient,
    createIntakeForm,
    resendClientInvite,
    deleteClient,
    getClientsById,
    editClient,
    getClientsContacts,
    getClientsContactInfo,
    createClientContact,
    editClientContact,
    deleteClientContact,
    editClientStatus,
    /** Client Enrollment */
    getEnrollmentPayers,
    getClientsEnrollment,
    editClientEnrollment,
    createClientEnrollment,
    terminateClientEnrollment,
    deleteClientEnrollment,
    changeEnrollmentType,
    /** End */

    // getClientsAuthorizations,
    // createClientsAuthorizations,
    // editClientsAuthorizations,
    // deleteClientsAuthorization,
    // getClientsAuthorizationsServ,
    // createClientsAuthorizationsServ,
    // editClientsAuthorizationsServ,
    // deleteClientsAuthorizationServ,
    // getClientsAuthorizationsServModifiersCheck,

    /** Client Address */
    addAddress,
    editAddress,
    deleteAddress,
    /** End */

    /** Client Scheduling Address */
    getSchedulingAddress,
    setSchedulingAddress,
    clearSchedulingAddress,
    /** End */

    /** Client Assignment */
    assignStaff,
    editAssignedStaff,
    getAssignedStaffs,
    removeClientStaff,
    /** End */

    /** Client Authorization */
    addClientAuthorization,
    editClientAuthorization,
    inactivateClientAuthorization,
    cancelClientAuthorization,
    deleteClientAuthorization,
    deleteAuthorizedService,
    clientAuthorizationVisible,
    removeClientAuthorization,
    getClientAuthorization,
    getAuthUtilization,
    getClientAuthorizationAppt,
    getClientsAuthorizationsAppt,
    /** Client Authorization Files*/
    getClientAuthFiles,
    addFilesToClientAuth,
    removeFilesFromClientAuth,
    editFileNameOfClientAuth,
    /** End */

    /** Forms */
    getClientForms,
    deleteClientForms,
    addClientForms,
    /** End */

    /** Client Sections */
    getClientSections,
    createClientSection,
    editClientSection,
    deleteClientSection,
    /** End */

    /** Link Contact */
    linkContactToClient,
    /** End */

    /** Portal Access */
    grantPortalAccess,
    revokePortalAccess,
    setClientContactPassword,
    /** End */

    /** Client Documentation Notes */
    getClientAllNotes,
    deleteClientAllNotes,
    /** End */
};
